import React from 'react';
import classnames from 'classnames';

export default function headlineProps(WrappedComponent) {
	return function EnhancedHeadline({
		rounded = false,
		light = false,
		centered = false,
		strong = false,
		size = 'medium',
		className,
		...rest
	}) {
		const computedClassName = classnames(
			'ph-headline',
			className,
			{
				rounded,
				light,
				centered,
				strong,
			},
			size,
		);
		return (
			<WrappedComponent
				{...rest}
				rounded={rounded}
				light={light}
				centered={centered}
				strong={strong}
				size={size}
				className={computedClassName}
			/>
		);
	};
}
